import React from "react";

const unstakingFaq = [
  {
    title: "How long does it take to unstake?",
    description: (
      <p>
        Our system will strive to match your unstaking request with available ETH,
        allowing you to withdraw immediately. However, if ETH liquidity is not available,
        please be aware of the Ethereum Network's unstaking queue. This process is beyond our control,
        as it hinges on network demand. You can check current Withdrawal queue length <a href="https://www.rated.network/overview?network=mainnet&timeWindow=all&rewardsMetric=average" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>here</a>.
        As soon as your ETH becomes available (in most cases immediately), you'll be able to get a withdrawal processed.
      </p>
    ),
  },
  {
    title: "Is it Possible to Withdraw Staked ETH at Any Time from BF's Staking Platform?",
    description: (
      <p>
        No, you cannot withdraw Staked ETH as the ETH are staked and locked on the blockchain.
        First you have to Unstake and then request a Withdrawal of ETH. 
      </p>
    ),
  },
];

export default unstakingFaq;
